module.exports = __webpack_public_path__ + "static/media/bg-empresa3.2115a8d7.png";